import { createSlice } from "@reduxjs/toolkit";

import { GetDailyDataDashUser, GetListDataHeigthOfUser } from './thunk';


const dataDashboardPlanSlice = createSlice({
    name: 'dataDashboardPlan',
    initialState: {
       
        dailyGoal : {},
        dailyProgress:{},
        data_heigth : [],
        massage: null
    },

    extraReducers: (builder) => {
        builder
          

          .addCase(GetDailyDataDashUser.pending, (state) => {
            
            state.massage = null;
          })
          .addCase(GetDailyDataDashUser.fulfilled, (state, action) => {
           
            state.dailyGoal = action.payload.data.dailyGoal; // Assure-toi que payload contient bien les données
            state.dailyProgress = action.payload.data.dailyProgress; // Assure-toi que payload contient bien les données
            console.log('action.payload', action.payload);
          })
          .addCase(GetDailyDataDashUser.rejected, (state, action) => {
           
            state.massage = action.payload || 'Erreur inconnue';
          })


          .addCase(GetListDataHeigthOfUser.pending, (state) => {
            
            state.massage = null;
          })
          .addCase(GetListDataHeigthOfUser.fulfilled, (state, action) => {
           
            state.data_heigth = action.payload; // Assure-toi que payload contient bien les données
            console.log('action.payload', action.payload);
          })
          .addCase(GetListDataHeigthOfUser.rejected, (state, action) => {
           
            state.massage = action.payload || 'Erreur inconnue';
          });
      },
    });
    
    export default dataDashboardPlanSlice.reducer;